var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-p"},[_c('div',{staticClass:"h30"})])
}]

export { render, staticRenderFns }